import $ from 'jquery';

$(function() {
  // Show more text option 
  var showChar_c = 250;  // How many characters are shown by default
  var ellipsestext_c = "...";
  var moretext_c = '<span class="cta--text">Show More</span><span class="cta--down-arrow-icon icon"></span>';
  var lesstext_c = '<span class="cta--text">Show Less</span><span class="cta--down-arrow-icon icon"></span>';
  
  //Cut content based on showChar_c length
  if ($(".other-contacts-cmp__body .other-contacts-cmp__text").length) {
      $(".other-contacts-cmp__body .other-contacts-cmp__text").each(function() {

          var content_c = $(this).html();
          console.log(content_c);
   
          if(content_c.length > showChar_c) {
   
              var contentExcert_c = content_c.substr(0, showChar_c);
              var contentRest_c = content_c.substr(showChar_c, content_c.length - showChar_c);
              var html_c = contentExcert_c +'<span class="cwm-toggle-text-ellipses">'+ellipsestext_c+'</span><span class="cwm-toggle-text-content"><span>'+contentRest_c +'</span> <a href="javascript:;" class="cwm-toggle-text-link">' + moretext_c + '</a></span>';
   
              $(this).html(html_c);
          }
      });
  }


  var minHeight = parseInt(0);
  // setting height of each card body text
  $(".other-contacts-cmp__card .other-contacts-cmp__text").each(function(){
      if($(this).outerHeight() > minHeight){
          minHeight = $(this).outerHeight();
      }
  });
  $('.other-contacts-cmp__card .other-contacts-cmp__text').css('min-height', minHeight);

  var footerMinHeight = parseInt(0);
  //setting height of each card footer links
  $(".other-contacts-cmp__card .other-contacts-cmp__footer").each(function(){
    if($(this).outerHeight() > footerMinHeight){
        footerMinHeight = $(this).outerHeight();
    }
  });
  $('.other-contacts-cmp__card .other-contacts-cmp__footer').css('min-height', footerMinHeight);

  //Toggle content when click on read more link
  $(".other-contacts-cmp__card .cwm-toggle-text-link").click(function(){
    var contactCard = $(this).closest(".other-contacts-cmp__card-wrapper");
    var contactCardRow = contactCard.parent();

      if($(this).hasClass("less")) {
          $(this).removeClass("less");
          $(this).html(moretext_c);
          $('.other-contacts-cmp__card .other-contacts-cmp__text').css('min-height', minHeight);
        
      } else {
          $(this).addClass("less");
          $(this).html(lesstext_c);
          $(this).closest('.other-contacts-cmp__card .other-contacts-cmp__text').css('min-height', 'auto');
          contactCardRow.css("align-items", "flex-start");
        }

      $(this).parent().prev().toggle();
      $(this).prev().toggle();
      return false;
  });
});


// WEBPACK FOOTER //
// ./components/cwm-other-contacts-cmp/scripts/cwm-other-contacts-cmp.js